import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

import { Team, CategoryDto, Language, TeamWithMembersDto } from '../../../shared/model';

@Component({
  selector: 'app-teams-filters',
  templateUrl: './teams-filters.component.html',
  styleUrls: ['../../../shared/styles/filters.css']
})
export class TeamsFiltersComponent implements OnInit, OnChanges {

  @Input() allTeams: Team[] = new Array<Team>();
  @Input() allEmptyTeams: Team[] = new Array<Team>();
  @Input() allCategories: CategoryDto[] = [];
  @Input() allLanguages: Language[] = [];
  @Input() allTeamsWithMembers: TeamWithMembersDto[];
  @Output() change: EventEmitter<TeamWithMembersDto[]> = new EventEmitter();

  selectedTeamFilters = [];
  selectedCategoryFilters = [];
  selectedLanguageFilters = [];
  initialized = false;
  filteredTeamsWithMembers: TeamWithMembersDto[];

  constructor() { }

  ngOnInit() {
    this.checkAllFilters();
    this.initialized = true;
  }

  ngOnChanges(changes) {
    if (!changes.allEmptyTeams.firstChange && changes.allEmptyTeams.previousValue.length < changes.allEmptyTeams.currentValue.length) {
      this.setCheckboxForNewTeam(changes.allEmptyTeams.previousValue, changes.allEmptyTeams.currentValue);
    }
  }

  isTeamChecked(team: Team): boolean {
    return this.selectedTeamFilters.find(t => t === team.Id) !== undefined;
  }

  isCategoryChecked(categoryId: string): boolean {
    return this.selectedCategoryFilters.find(c => c === categoryId) !== undefined;
  }

  isLanguageChecked(languageId: string): boolean {
    return this.selectedLanguageFilters.find(l => l === languageId) !== undefined;
  }

  teamFilterChange(team: Team) {
    const index = this.selectedTeamFilters.findIndex(t => t === team.Id);
    index > -1 ? this.selectedTeamFilters.splice(index, 1) : this.selectedTeamFilters.push(team.Id);

    this.applyFilter();
  }

  categoryFilterChange(category: CategoryDto) {
    const index = this.selectedCategoryFilters.findIndex(c => c === category.Id);
    index > -1 ? this.selectedCategoryFilters.splice(index, 1) : this.selectedCategoryFilters.push(category.Id);

    this.applyFilter();
  }

  languageFilterChange(language: Language) {
    const index = this.selectedLanguageFilters.findIndex(l => l === language.Id);
    index > -1 ? this.selectedLanguageFilters.splice(index, 1) : this.selectedLanguageFilters.push(language.Id);

    this.applyFilter();
  }

  private checkAllFilters() {
    this.selectedCategoryFilters = this.allCategories.map(c => c.Id);
    this.selectedLanguageFilters = this.allLanguages.map(l => l.Id);
    this.selectedTeamFilters = this.allTeams.map(t => t.Id);
  }

  private applyFilter() {
    this.filteredTeamsWithMembers = this.deepCopyTeams();
    this.filteredTeamsWithMembers = this.filteredTeamsWithMembers.filter(t => this.selectedTeamFilters.indexOf(t.TeamId) > -1);

    this.filteredTeamsWithMembers.forEach(ft => {
      ft.Supporters = ft.Supporters.filter(s => s.LanguageIds.find(l => this.selectedLanguageFilters.indexOf(l) > -1)
      && s.CategoryIds.find(c => this.selectedCategoryFilters.indexOf(c) > -1));
    });

    const filteredEmptyTeams = this.allEmptyTeams.filter(t => this.selectedTeamFilters.indexOf(t.Id) > -1).map(item => <TeamWithMembersDto>{
      Supporters: [],
      TeamId: item.Id
    });

    this.filteredTeamsWithMembers = this.filteredTeamsWithMembers.concat(filteredEmptyTeams);
    this.change.emit(this.filteredTeamsWithMembers);
  }

  private deepCopyTeams(): TeamWithMembersDto[] {
    const result: TeamWithMembersDto[] = [];
    this.allTeamsWithMembers.forEach(tm => {
      const supporters = [...tm.Supporters];
      result.push(<TeamWithMembersDto>{
        Supporters: supporters,
        TeamId: tm.TeamId
      });
    });

    return result;
  }

  private setCheckboxForNewTeam(previousValue, currentValue) {
    const newTeam = currentValue.find(t => previousValue.find(p => p.Id === t.Id) === undefined);
    this.selectedTeamFilters.push(newTeam.Id);
    this.applyFilter();
  }
}
